// extracted by mini-css-extract-plugin
module.exports = {"section":"DashboardSection_section__22UHm","header":"DashboardSection_header__1rDER"};